import {
    forwardRef, useEffect, useRef, useState,
  } from 'react';
import TextInput from './base/TextInput';
import Icons from './Icons';
import clsx from 'clsx';
import GeoService from '../services/GeoService';
import CountrySelect from './CountrySelect';
import './scss/TextInput.scss';
import './scss/form.scss';
import './scss/Search.scss';
  
  const FieldValidations = {
    BLANK: 'blank',
    EMAIL: 'email',
  };
  
  const FormField = forwardRef(({
    type = 'text',
    name,
    label,
    value,
    error,
    isRequired,
    onChange,
    onBlur,
    options,
    height,
    readOnly,
    placeholder,
    maxLength,
    icon,
    link,
    iconSuffix,
    onClick,
    width,
    autoComplete,
    bottomLabel,
    border,
    backgroundColor,
    borderRadius,
    labelColor,
    bottomRemove,
    onKeyDown,
    parentWidth,
    instruction,
    isDisabled,
    info,
    states,
    templateType,
    admin = false,
  }, ref) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const iconRef = useRef(null);
    const tooltipRef = useRef(null);
    const [tooltipHeight, setTooltipHeight] = useState(0);
  
  
    useEffect(() => {
      if (tooltipRef.current) {
        setTooltipHeight(tooltipRef.current.offsetHeight);
      }
    }, [showTooltip, info]);
  
    function renderTextBox() {
      return (
        <TextInput
          type={type}
          name={name}
          maxLength={maxLength}
          label={label}
          iconPrefix={icon}
          value={value}
          error={error}
          link={link}
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          readOnly={readOnly}
          iconSuffix={iconSuffix}
          onClick={onClick}
          width={width}
          autoComplete={autoComplete}
          border={border}
          backgroundColor={backgroundColor}
          onKeyDown={onKeyDown}
          isDisabled={isDisabled}
        />
      );
    }
    function renderAuthTextBox() {
        const showDefault = (name === 'portalName' && value === '') || (name === 'portalName' && value);
        const defaultStyle = {
          position: 'absolute',
          top: error ? 'calc(100% - 65%)' : 'calc(100% - 50%)',
          right: '8px',
          transform: 'translateY(-55%)',
          paddingTop: '10px',
          paddingBottom: '5px',
        };
    
        return (
          <div style={{ position: 'relative' }}>
            <TextInput
              type={type}
              name={name}
              maxLength={maxLength}
              label={label}
              iconPrefix={icon}
              value={value}
              error={error}
              link={link}
              ref={ref}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
              readOnly={readOnly}
              iconSuffix={iconSuffix}
              onClick={onClick}
              width={width}
              autoComplete={autoComplete}
              border="'1px solid transparent'"
              backgroundColor="var(--light-green)"
              isErrorTrigger={false}
            />
            {showDefault && <div style={defaultStyle}><span style={{ color: 'black', display: 'flex', alignItems: 'end' }}>.orkaapps.com</span></div>}
          </div>
        );
      }
      function renderPasswordTextBox() {
        return (
          <TextInput
            type="password"
            name={name}
            value={value}
            ref={ref}
            onChange={onChange}
            onBlur={onBlur}
            isPassword
            placeholder={placeholder}
            error={error}
            autoComplete={autoComplete}
            iconSuffix={iconSuffix}
            maxLength={maxLength}
            border={border}
            backgroundColor="var(--light-green)"
            // isErrorTrigger={false}
          />
        );
      }
    function renderTextArea() {
      return (
        <div
          className={clsx('ui-textinput', {
            'ui-textinput--invalid': !!error,
          })}
        >
          <div className="ui-textinput__input-wrapper" style={{ height: 'auto' }}>
            <textarea
              name={name}
              label={label}
              className="ui-textinput__input"
              style={{ resize: 'vertical', minHeight: height || 110, width: '100%', height: 'auto', boxSizing: 'border-box' }}
              maxLength={maxLength}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              onWheel={(event) => event.target.blur()}
            />
          </div>
          {error && <div className="ui-textinput__error">{error}</div>}
        </div>
      );
    }

  function renderAuthCountrySelectBox() {
    return (
      <CountrySelect
        name={name}
        options={GeoService.getCountries().map((country) => ({
          name: country.name,
          value: country.code,
        }))}
        onChange={onChange}
        value={value}
        borderRadius={borderRadius}
        border="'1px solid transparent'"
        backgroundColor="var(--light-green)"
      />
    );
  }
    function renderContent() {
        if (type === 'text' || type === 'number') {
          return renderTextBox();
        }
        if (type === 'auth-text') {
          return renderAuthTextBox();
        }
        if (type === 'password') {
          return renderPasswordTextBox();
        }
        if (type === 'textarea') {
          return renderTextArea();
        }
        if (type === 'auth-country') {
      return renderAuthCountrySelectBox();
    }
        throw new Error('invalid form field type');
      }
      function toolTip(texts) {
        const iconRect = iconRef.current?.getBoundingClientRect();
        const adjustedTop = iconRect ? iconRect.top - tooltipHeight - 10 : 0;
        return (
          <div 
          ref={tooltipRef}
          style={{
            position: 'absolute',
            top: adjustedTop,
            left: iconRect ? iconRect.left + iconRect.width / 2 - 50 : 0,
            backgroundColor: 'white',
            color: 'red',
            border: '1px solid rgb(234, 234, 234)',
            padding: '5px',
            maxWidth: '550px',
            wordWrap: 'break-word',
          }}>
            {texts}
          </div>
        )
      }
    
      return (
        <div className="ui-form-field" style={{ marginBottom: bottomRemove && 0, width: parentWidth }}>
          {label && type !== 'checkbox' && (
            <><div className="ui-form-field__label" style={{ color: labelColor }}>
              {label}
              {isRequired && <span style={{ color: '#CA3521', marginLeft: 2 }}>*</span>}
              {info && (
              <div style={{
              cursor: 'pointer',
              display: 'inline-block',
              marginLeft: 20,
            }}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            ref={iconRef}
            > 
              {showTooltip && info && toolTip(info)}
             {Icons.Info}
              </div>
              )}
            </div>
            </>
          )}
          {renderContent()}
          {bottomLabel && <div className="ui-form-field__label" style={{ paddingTop: 5, color: 'var(--gray)' }}>{bottomLabel}</div>}
        </div>
      );
    });
    export default FormField;